import React from 'react';
import { string } from 'prop-types';
import LazyLoadWhenInView from './LazyLoadWhenInView';
import ProductDescription from './ProductDescription';

/**
 * @param {import('prop-types').InferProps<LazyLoadProductDescriptionProps>} props
 */
const LazyLoadProductDescription = ({ descriptionHtml }) => {
    return descriptionHtml && String(descriptionHtml).trim().length > 0 ? (
        <LazyLoadWhenInView>
            <ProductDescription
                descriptionHtml={descriptionHtml}
            />
        </LazyLoadWhenInView>
    ) : <div>Fast Shipping. Order Today!</div>;
};

const LazyLoadProductDescriptionProps = {
    descriptionHtml: string,
};
LazyLoadProductDescription.propTypes = LazyLoadProductDescriptionProps;
export default LazyLoadProductDescription;
